



























































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import SearchIcon from 'mdi-vue/Magnify';
import AddIcon from 'mdi-vue/Plus';
import EditIcon from 'mdi-vue/Pencil';
import ToggleSwitchOffIcon from 'mdi-vue/ToggleSwitchOff';
import ToggleSwitchIcon from 'mdi-vue/ToggleSwitch';
import LayoutTitle from '@/components/LayoutTitle.vue';
import Select from '@/components/Select.vue';
import FormInput from '@/components/FormInput.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import ScrollWrapper from '@/components/ScrollbarWrapper.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import api from '@/libs/api';
import {
  InvoiceListProfileResponse, User, InvoiceProfile,
} from '@/libs/api.interfaces';

@Component({
  components: {
    LayoutTitle,
    Select,
    FormInput,
    SearchIcon,
    LayoutContent,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    ScrollWrapper,
    StatusIndicator,
    ActionPopup,
    EditIcon,
    ToggleSwitchOffIcon,
    ToggleSwitchIcon,
  },
  computed: mapState(['user']),
})
export default class ProfileList extends Vue {
  user!: {
    user: User;
  };

  merchantId = 0;
  loading = true;
  profiles: InvoiceProfile[] = [];

  async getProfiles() {
    try {
      this.loading = true;
      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.post<InvoiceListProfileResponse>('/easyinvoice/profiles', {
        user_group: 0,
        merch_id: this.merchantId,
      });

      this.profiles = data.profile;
      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  async toggleStatus(id: string, status: boolean) {
    try {
      this.loading = true;
      /* eslint-disable @typescript-eslint/camelcase */
      await api.post(`/easyinvoice/${status ? 'profiles_activated' : 'profiles_deactivated'}`, {
        id,
      });

      this.getProfiles();
    } catch (err) {
      console.error(err);
    }
  }

  mounted() {
    this.merchantId = this.user.user.merchant_id;
    this.getProfiles();
  }
}
